
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const Privacy = () => {
  const { t } = useLanguage();
  
  return (
    <div className="container mx-auto px-4 py-16 min-h-screen">
      <a
        href="/"
        className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to home
      </a>
      
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy for Aurora Multimedia App</h1>
        
        <div className="prose prose-gray max-w-none">
          <p className="mb-4">Last updated: April 23, 2025</p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">AI-Powered Application Disclaimer</h2>
          <p className="mb-4 italic bg-yellow-50 p-4 rounded-md border border-yellow-200">
            This application has been made using an AI-powered tool. While every effort has been made to ensure accuracy, 
            errors may occasionally occur. Aurora Multimedia accepts no responsibility for any inaccuracies resulting 
            from this. Users of this app should always check full details with Aurora Multimedia.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Introduction</h2>
          <p className="mb-4">
            Aurora Multimedia Corp. ("we", "our", or "us") respects your privacy and is committed to 
            protecting your personal data. This privacy policy will inform you about how we look after 
            your personal data when you visit our website or use the Aurora Multimedia App and inform you of your privacy rights and 
            how the law protects you.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Information We Collect</h2>
          <p className="mb-4">
            We may collect, use, store and transfer different kinds of personal data about you which 
            we have grouped together as follows:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Identity Data includes first name, last name, company name, and title.</li>
            <li>Contact Data includes email address, telephone numbers, and physical address.</li>
            <li>Technical Data includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
            <li>Usage Data includes information about how you use our website and products.</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">How We Use Your Information</h2>
          <p className="mb-4">
            We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>To provide you with information about our products and services.</li>
            <li>To process and respond to inquiries and requests for product information or support.</li>
            <li>To improve our website and present its contents to you.</li>
            <li>For internal record keeping and administrative purposes.</li>
            <li>To comply with our legal obligations.</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Data Security</h2>
          <p className="mb-4">
            We have put in place appropriate security measures to prevent your personal data from being 
            accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, 
            we limit access to your personal data to those employees, agents, contractors and other third 
            parties who have a business need to know.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">Contact Us</h2>
          <p className="mb-4">
            If you have any questions about this privacy policy or our privacy practices, please contact us at:
          </p>
          <p className="mb-4">
            Aurora Multimedia Corp.<br />
            205 Commercial Court<br />
            Morganville, NJ 07751<br />
            USA<br />
            Phone: +1 732-591-5800<br />
            Email: info@auroramm.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
